import React from 'react'
import { Loader } from 'semantic-ui-react';

import CountCardHeader from './../Drive/Cards/CountCardHeader';
import ThreeBlockDivision from '../Drive/Cards/ThreeBlockDivision'
import PbBlock from '../Drive/Cards/PbBlock'; // PbBlock is added for KLM-8944
import TwoBlockWithHeader from './../Drive/Cards/TwoBlockWithHeader'
import playbook from "../../../../images/svg/noti-designer.svg";
class CountBlock extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false
        }
    }

    componentWillMount() {
        this.setState({ loading: true });
        setTimeout(
            function () {
                this.setState({ loading: false });
            }.bind(this), 2000);
    }


    render() {

        let showLoader = this.state.loading || this.props.loadingPlaybook;
        let totlaCount = this.props.packCount[0] + this.props.packCount[2] + this.props.packCount[3] + this.props.packCount[4] + this.props.packCount[5] + this.props.packCount[6] + this.props.packCount['inReview'] + this.props.packCount['forReview'] + this.props.packCount['generating']
        return (
            <div>
                <div className="display-flow-root">
                    <CountCardHeader
                        name="Playbook"
                        type="playbook"
                        image={playbook}
                        totalCount={totlaCount}
                        selectedOrganisation={this.props.selectedOrganisation}
                    />
                </div>
                {showLoader ?
                    <div className="setLoader" style={{ padding: "61px 0" }}>
                        <Loader active inline />
                    </div> : ""}
                <div className="count-content">
                    <PbBlock
                        type="playbook"
                        selectedAccount={this.props.selectedAccount}
                        user={this.props.user}
                        selectedOrganisation={this.props.selectedOrganisation}
                        history={this.props.history}
                        isLoadingData={this.props.isLoadingData}
                        label1Name="In Design"
                        label1Count={showLoader ? 0 : this.props.packCount[0]}
                        label2Name="Approved"
                        label2Count={showLoader ? 0 : this.props.packCount[2]}
                        label3Name="Published"
                        label3Count={showLoader ? 0 : this.props.packCount[4]}
                        label4Name="Inactive"
                        label4Count={showLoader ? 0 : this.props.packCount[5]}
                        label5Name="Generating"
                        label5Count={showLoader ? 0 : this.props.packCount['generating']}
                    />
                    <TwoBlockWithHeader
                        header="Review Requests"
                        type="playbook"
                        selectedOrganisation={this.props.selectedOrganisation}
                        user={this.props.user}
                        history={this.props.history}
                        label1Name="Received"
                        label1Count={showLoader ? 0 : this.props.packCount['forReview']}
                        label2Name="Sent"
                        label2Count={showLoader ? 0 : this.props.packCount['inReview']}
                    />
                </div>
            </div>
        )
    }
}

export default CountBlock;